import React from 'react';
import PropTypes from 'prop-types';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from 'pure-react-carousel';
import useWindowSize from '../../../utils/useWindowSize';

import { sizes } from '../ui/common';
import { Wrap, Tiny, Row } from './styled';

function ImageSlider({ activeSlideIndex, images, setActiveSlideIndex }) {
  const size = useWindowSize();

  const prev = () => {
    setActiveSlideIndex((v) => (v <= 0 ? v : v - 1));
  };
  const next = () => {
    setActiveSlideIndex((v) => (v >= images.length - 1 ? v : v + 1));
  };
  const minTablet = size.width > sizes.phone;

  return (
    <CarouselProvider
      visibleSlides={minTablet ? 4 : 1}
      naturalSlideHeight={minTablet ? 80 : 252}
      naturalSlideWidth={100}
      totalSlides={images.length}
    >
      <Row>
        {minTablet && (
          <ButtonBack onClick={prev}>
            <Arrow direction="toLeft" />
          </ButtonBack>
        )}
        <Wrap>
          <Slider>
            {images.map((item, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Slide key={i} index={i} onClick={() => setActiveSlideIndex(i)}>
                <Tiny image={item} $active={activeSlideIndex === i} alt="" />
              </Slide>
            ))}
          </Slider>
          {!minTablet && <DotGroup />}
        </Wrap>
        {minTablet && (
          <ButtonNext onClick={next}>
            <Arrow direction="toRight" />
          </ButtonNext>
        )}
      </Row>
    </CarouselProvider>
  );
}

export default ImageSlider;

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
  activeSlideIndex: PropTypes.number.isRequired,
  setActiveSlideIndex: PropTypes.func.isRequired,
};
ImageSlider.defaultProps = {
  images: [],
};

function Arrow({ direction }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 8"
      width="33"
      hanging="8"
    >
      {direction === 'toRight' ? (
        <path d="M32.354 4.354a.5.5 0 000-.708L29.172.464a.5.5 0 10-.707.708L31.293 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM0 4.5h32v-1H0v1z" />
      ) : (
        <path d="M.646 4.354a.5.5 0 010-.708L3.828.464a.5.5 0 11.708.708L1.707 4l2.829 2.828a.5.5 0 11-.708.708L.646 4.354zM33 4.5H1v-1h32v1z" />
      )}
    </svg>
  );
}

Arrow.propTypes = {
  direction: PropTypes.oneOf(['toLeft', 'toRight']),
};
Arrow.defaultProps = {
  direction: 'toLeft',
};
